import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f7fdb94"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["RadioGroup", { disabled: _ctx.disabled }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["RadioGroup__radio", { active: _ctx.value === option[_ctx.selectBy], red: _ctx.red }]),
        key: option,
        onClick: ($event: any) => (_ctx.emitUpdate(option))
      }, _toDisplayString(option[_ctx.label]), 11, _hoisted_1))
    }), 128))
  ], 2))
}